import React from 'react';
import { FaTwitter, FaLinkedin, FaGithub, FaDiscord, FaYoutube, FaArrowRight } from 'react-icons/fa';
import { IoMdFlash } from 'react-icons/io';
import { FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0A0A0F] to-[#050507] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4 group">
              <IoMdFlash className="text-purple-400 text-2xl group-hover:rotate-12 transition-transform duration-300" />
              <span className="text-xl font-bold gradient-text">Studio Pulse</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              AI-powered prospecting platform that helps revenue teams find and engage ideal customers with autonomous intelligence.
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"><FaTwitter /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"><FaLinkedin /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"><FaGithub /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"><FaDiscord /></a>
              <a href="#" className="text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"><FaYoutube /></a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">Product</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Features</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Pricing</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Demo</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Integrations</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">API</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">About</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Blog</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Careers</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Contact</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Press</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Documentation</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">API Reference</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Support</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Status</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Community</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-white">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Privacy</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Terms</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Security</a></li>
              <li><a href="#" className="hover:text-white transition-all duration-300 hover:translate-x-1 inline-block">Cookies</a></li>
            </ul>
          </div>
        </div>
        
        {/* Newsletter Section */}
        <div className="border-t border-white/10 mt-10 pt-8">
          <div className="max-w-md">
            <h4 className="font-semibold mb-2 text-white">Subscribe to our newsletter</h4>
            <p className="text-sm text-gray-400 mb-3">Get the latest updates on AI prospecting</p>
            <div className="flex gap-2">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="flex-1 px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:border-purple-500 transition-all"
              />
              <button className="bg-gradient-to-r from-purple-600 to-indigo-600 px-4 py-2 rounded-lg hover:shadow-lg transition-all group">
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2024 LeadFlow AI. All rights reserved.</p>
          <div className="flex gap-6 text-sm text-gray-500">
            <a href="#" className="hover:text-white transition">Privacy Policy</a>
            <a href="#" className="hover:text-white transition">Terms of Service</a>
            <a href="#" className="hover:text-white transition">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;